/** Inline toolbar icons (match ~20px gear size in 34px buttons). */

export function webCompactLayoutIcon(): string {
  return `<svg class="sfe-web-toolbar-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <rect x="3" y="5" width="5" height="14" rx="1.2" fill="currentColor"></rect>
    <rect x="16" y="5" width="5" height="14" rx="1.2" fill="currentColor"></rect>
    <path d="M10.25 12h3.5M10.25 9.25 8.75 12l1.5 2.75M13.75 9.25 15.25 12l-1.5 2.75" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>
  </svg>`;
}
